import React from 'react'

function InputText(props) {
    return (
        <input className={`${"form_page_input"}`} type={props.type ? props.type : "text"} autocomplete="false"  id={props.name} placeholder={props.FieldPlaceHolder} name={props.name} {...props} />    )
}

export default InputText
